import { render, staticRenderFns } from "./Laravel-Vue-Pagination.vue?vue&type=template&id=133fb3ac&"
import script from "./Laravel-Vue-Pagination.vue?vue&type=script&lang=js&"
export * from "./Laravel-Vue-Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports